/// <amd-module name="Wit/Common/WorkItemDialogs/Components/InsertSharedStepsDialog" />
import * as React from "react";
import { Components } from "VSS/Platform/Layout";
import { ContentSize } from "VSSUI/Callout";
import { Dialog, IDialogProps } from "VSSUI/Dialog";
import * as Resources from "Wit/Common/WorkItemDialogs/Resources";
import { SelectTestItemForm } from "./SelectTestItemForm";

interface IInsertSharedStepsDialogProps extends Pick<IDialogProps, "onDismiss"> {
    onInsertSharedSteps(ids: number[]): void;
    onDismiss(): void;
}

interface ISharedStepsDialogState {
    selectedIds?: number[];
}

export const InsertSharedStepsDialog: React.FunctionComponent<IInsertSharedStepsDialogProps> = ({ onDismiss, onInsertSharedSteps }) => {
    const [selectedIds, setSelectedIds] = React.useState<number[] | undefined>(undefined);

    const onClickInsertSteps = () => {
        selectedIds && onInsertSharedSteps(selectedIds);
        onDismiss();
    };

    const onSelectionChanged = (workItemIds: number[]) => {
        setSelectedIds(workItemIds);
    };

    return (
        <Dialog
            className="insert-shared-steps-dialog"
            footerButtonProps={[
                { onClick: onDismiss, text: Resources.Cancel },
                { disabled: !selectedIds, onClick: onClickInsertSteps, primary: true, text: Resources.InsertSharedSteps }
            ]}
            onDismiss={onDismiss}
            titleProps={{ text: Resources.InsertSharedSteps }}
            contentSize={ContentSize.Large}
        >
            <SelectTestItemForm testItemType="Microsoft.SharedStepCategory" onMultiSelectionChanged={onSelectionChanged} multipleSelect />
        </Dialog>
    );
};

Components.add("insert-shared-steps-dialog", InsertSharedStepsDialog);
